import { render, staticRenderFns } from "./RoomDisplayView.vue?vue&type=template&id=3bb8a2a6&scoped=true"
import script from "./RoomDisplayView.vue?vue&type=script&lang=js"
export * from "./RoomDisplayView.vue?vue&type=script&lang=js"
import style0 from "./RoomDisplayView.vue?vue&type=style&index=0&id=3bb8a2a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb8a2a6",
  null
  
)

export default component.exports